import React, { memo, useContext, useEffect, useState } from "react";
import { Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Contexts from "@/components/Layout/Contexts";
import { ICustomRouterConfig } from "../../routers";
import { IState } from "@/store/index";

export default memo((props: { mode: "vertical" | "horizontal" | "inline" }) => {
  const { mode } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const breadContext = useContext(Contexts);
  const routes = useSelector<IState, ICustomRouterConfig[]>(
    (state) => state.globle.routes
  );
  const [menus, setMenus] = useState([]);
  const [path, setPath] = useState([]);
  const [openKeys, setOpenKeys] = useState<string[]>([
    "/" + location.pathname.split("/")[1],
  ]);

  const initRouteMenu = (routes) => {
    const format = (routes) => {
      if (!routes) return [];
      return routes.map((route) => {
        const item: any = {
          key: route.path,
          icon: route.icon ? route.icon : <></>,
          label: route.label,
        };
        if (route.children && route.children.length) {
          item.children = format(route.children);
        }
        return item;
      });
    };

    const filter = (routes) => {
      return routes.filter((route) => {
        if (route.children && route.children.length) {
          route.children = filter(route.children);
        }
        return route.show;
      });
    };

    const filterData = filter(routes);
    const formatData = format(filterData);
    setMenus(formatData);
  };

  //点击菜单
  const onSelect = (menuInfo) => {
    if (location.pathname)
      if (
        !breadContext.breadItem.includes(menuInfo.domEvent.target.innerText)
      ) {
        breadContext.breadItem.push({
          name: menuInfo.domEvent.target.innerText,
          path: location.pathname,
        });
      }
    breadContext.setBreadItem([...breadContext.breadItem]);
    navigate(menuInfo.key);
    setPath(menuInfo.key);
  };

  useEffect(() => {
    if (routes[0]) {
      initRouteMenu(routes[0].children);
    }
  }, [routes]);

  useEffect(() => {
    //目前只会出现两级菜单， 为了处理按钮页面地址栏三级导致左侧菜单选中状态没有
    setPath(["/" + location.pathname.split("/").slice(1, 3).join("/")]);
  }, [location.pathname]);

  return (
    <Menu
      theme={"light"}
      mode={mode}
      onOpenChange={(openItemInfo) => {
        setOpenKeys([openItemInfo[openItemInfo.length - 1]]);
      }}
      selectedKeys={path}
      style={{ height: "100%", borderRight: 0 }}
      items={menus}
      onSelect={onSelect}
      openKeys={openKeys}
    />
  );
});
